import React, { useState, useEffect, useRef, useContext } from "react";

// ------------------ COMPONENTES DE PRIMEREACT --------------------------
import { Button, Dialog, InputText, Toast } from "primereact";

// ------------------ COMPONENTES DE BASE --------------------------------
import { useForm } from "../../../../Base/Hooks/useForm";
import Loader from "../../../../Base/Components/Loader/Loader";
import { toastShow } from "../../../../Base/Services/ToastService";
import { getAreasAct } from "../../../../Base/API/Global/Areas/AreasRequests";
import { AuthContext } from "../../../../Base/Context/AuthContext/AuthContext";
import AutoCompleteDropdown from "../../../../Base/Components/Form/AutoCompleteDropdown";
import {  getTypesCategoria } from "../../../../Base/API/Global/Types/TypeRequest";

// ------------------- CONSULTAS A LA API --------------------------------
import { getEstadosCategory } from "../../../../API/Global/Status/StatusRequests";
import { EditarVehiculo, getColores, getVehiculos, GuardarVehiculo } from "../../../../API/Global/Vehiculos/VehiculosRequest";


const VehiculosCRUD = ({
    showDialog,
    selected,
    setShowDialog,
    getInfo,
    modo,
}) => {
  const toastDialog = useRef(null);
  const toast = useRef(null);
  const { userAuth } = useContext(AuthContext);

  const [loading, setLoading] = useState(false);
  const [tipos, setTipos] = useState([]);
  const [areas, setAreas] = useState([]);
  const [estados, setEstados] = useState([]);
  const [colores, setColores] = useState([]);
  const [vehiculosList, setVehiculosList] = useState([]);

  const initialValues = {
    IdVehiculo: -1,
    IdEstado: selected?.IdEstado ? selected?.IdEstado : 5,
    StatusName: selected?.StatusName ? selected?.StatusName : 'Activo'
  };

  const { values, handleInputChange, setValues, resetForm, error, setError } = useForm(initialValues);

  const getValoresIniciales = async () => {
    setLoading(true);
 
    const tiposTempo = await getTypesCategoria('Vehiculos')
    setTipos(tiposTempo)

    const areasTempo = await getAreasAct()
    setAreas(areasTempo)


    const estadosTempo = await getEstadosCategory('General')
    setEstados(estadosTempo)

    const coloresTempo = await getColores()
    setColores(coloresTempo)

    const vehiculosTempo = await getVehiculos()
    setVehiculosList(vehiculosTempo)

    setValues({
        ...selected
    })

    setLoading(false);
  };

  const onHide = () => {
    setShowDialog(false);
    resetForm();
  };

  const verificarInfo = () => {
    let error = {};

    if (!values.Marca) {
      error.Marca = true;
      error.error = true;
    }
    if (!values.Placa) {
        error.Placa = true;
        error.error = true;
    }
    if (!values.ColorEs?.IdColor && !values?.IdColor) {
        error.ColorEs = true;
        error.error = true;
    }
    if (!values.Type?.IdType && !values?.IdType) {
        error.Type = true;
        error.error = true;
    }
    if (!values.Area?.IdArea && !values?.IdArea) {
        error.Area = true;
        error.error = true;
    }
    if (!values.StatusName?.IdStatus && !values?.IdEstado) {
        error.StatusName = true;
        error.error = true;
    }


    setError(error);
    return error;
  };

  const agregarInformacion = async () => {
    const e = verificarInfo();
    if(!e?.error){


        const placaExistente = vehiculosList.find((e) => e.Placa === values?.Placa && e.IdVehiculo !== values?.IdVehiculo)

        if(placaExistente){
            toastShow(toast, "error", "Error", 'Ya existe la placa ingresada');
        }else{
            const Datos = {
                IdVehiculo: values?.IdVehiculo ? values?.IdVehiculo : -100,
                Marca: values?.Marca,
                Modelo: values?.Modelo,
                Placa: values?.Placa,
                Serie: values?.Serie,
                IdType: values?.Type?.IdType || values?.IdType,
                IdColor: values?.ColorEs?.IdColor || values?.IdColor,
                IdArea: values?.Area?.IdArea || values?.IdArea,
                IdEstado: values?.StatusName?.IdStatus || values?.IdEstado,
                IdUserCreate: userAuth?.IdUser,
                IdUserEdit: userAuth?.IdUser,
                Comentario: values?.Comentario,
            }
    

            setLoading(true)
            if(Datos?.IdVehiculo > 0){
                const respuesta = await EditarVehiculo(Datos)
                if (respuesta[0].ESTADO !== -1) {
                    toastShow(toast, "success", "Editada", respuesta[0].MENSAJE);
                    setTimeout(() => {
                        onHide();
                        setLoading(false);
                        getInfo();
                    }, 1500);
                } else {
                    toastShow(toast, "error", "Error", respuesta[0].MENSAJE);
                    setLoading(false);
                }
            }else{
                const respuesta = await GuardarVehiculo(Datos)
                if (respuesta[0].ESTADO !== -1) {
                    toastShow(toast, "success", "Guardado", respuesta[0].MENSAJE);
                    setTimeout(() => {
                        onHide();
                        setLoading(false);
                        getInfo();
                    }, 1500);
                } else {
                    toastShow(toast, "error", "Error", respuesta[0].MENSAJE);
                    setLoading(false);
                }
            }
        }

    }
  };

  const DialogFooter = (
    <React.Fragment>
      <Button
        label="Cancelar"
        icon="pi pi-times"
        className="p-button-text"
        onClick={onHide}
      />
      <Button
        label={"Guardar"}
        icon="pi pi-check"
        className="p-button-text"
        onClick={agregarInformacion}
        loading={loading}
      />
    </React.Fragment>
  );

  useEffect(() => {
    if (showDialog) {
        getValoresIniciales();
    }
  }, [showDialog]);

  const dialogTitle = modo === "Crear" ? "Agregar Vehículo" : "Editar Vehículo";

  return (
    <div>
      <Dialog
        visible={showDialog}
        modal
        className="modal__contenedor modal__usuarios"
        footer={DialogFooter}
        onHide={onHide}
      >
      <Toast ref={toast} style={{ zIndex: 50000 }} />
        <div id="Dialog">
          <Loader loading={loading} querySelector={"#Dialog"} />
          <div style={{ width: "100", margin: "auto" }}>
            <div className="d-flex align-items-center">
              <h2 className="me-3">{dialogTitle}</h2>
            </div>
            <Toast ref={toastDialog} style={{ zIndex: 50000 }} />

            <div className="modal__input-contenedor">
              <div className="field col-6 me-2  mt-2">
                <span className="p-float-label">
                  <InputText
                    name="Marca"
                    value={values.Marca}
                    onChange={handleInputChange}
                    style={{ width: "100%" }}
                    labelStyle={{
                      color: "gray",
                      textShadow: "0px 0px 1px white",
                    }}
                    className={error.Marca ? "p-invalid" : ""}
                  />
                  <label htmlFor="Marca">Marca</label>
                </span>
              </div>

              <div className="field col-6 me-2  mt-2">
                <span className="p-float-label">
                  <InputText
                    name="Modelo"
                    value={values.Modelo}
                    onChange={handleInputChange}
                    style={{ width: "100%" }}
                    labelStyle={{
                      color: "gray",
                      textShadow: "0px 0px 1px white",
                    }}
                    className={error.Modelo ? "p-invalid" : ""}
                  />
                  <label htmlFor="Modelo">Modelo</label>
                </span>
              </div>
 
            </div>

            <div className="modal__input-contenedor">
              <div className="field col-6 me-2  mt-2">
                <span className="p-float-label">
                  <InputText
                    name="Placa"
                    value={values.Placa}
                    onChange={handleInputChange}
                    style={{ width: "100%" }}
                    className={error.Placa ? "p-invalid" : ""}
                  />
                  <label htmlFor="Placa">Placa</label>
                </span>
              </div>

              <div className="field col-6 me-2  mt-2">
                <span className="p-float-label">
                  <InputText
                    name="Serie"
                    value={values.Serie}
                    onChange={handleInputChange}
                    style={{ width: "100%" }}
                    className={error.Serie ? "p-invalid" : ""}
                  />
                  <label htmlFor="Serie">Serie</label>
                </span>
              </div>
            </div>

            <div className="modal__input-contenedor">
              <div className="field col-6 me-2 mt-2">
                <span className="p-float-label">
                  <AutoCompleteDropdown
                    name={"Type"}
                    value={values.Type}
                    items={tipos}
                    field={"Type"}
                    label={"Tipo"}
                    handleInputChange={handleInputChange}
                    className={error.Type ? "p-invalid" : ""}
                  />
                </span>
              </div>

              
              <div className="field col-6 me-2 mt-2">
                <span className="p-float-label">
                  <AutoCompleteDropdown
                    name={"ColorEs"}
                    value={values.ColorEs}
                    items={colores}
                    field={"ColorEs"}
                    label={"Color"}
                    handleInputChange={handleInputChange}
                    className={error.ColorEs ? "p-invalid" : ""}
                  />
                </span>
              </div>

            </div>

            <div className="modal__input-contenedor">

            <div className="field col-6 me-2 mt-2">
                <span className="p-float-label">
                  <AutoCompleteDropdown
                    name={"Area"}
                    value={values.Area}
                    items={areas}
                    field={"Area"}
                    label={"Area"}
                    handleInputChange={handleInputChange}
                    className={error.Area ? "p-invalid" : ""}
                  />
                </span>
              </div>

              <div className="field col-6 me-2 mt-2">
                <span className="p-float-label">
                  <AutoCompleteDropdown
                    name={"StatusName"}
                    value={values.StatusName}
                    items={estados}
                    field={"StatusName"}
                    label={"Estado"}
                    handleInputChange={handleInputChange}
                    className={error.StatusName ? "p-invalid" : ""}
                  />
                </span>
              </div>
            </div>

            <div className="modal__input-contenedor">
                <div className="field col-6 me-2  mt-2">
                    <span className="p-float-label">
                    <InputText
                        name="Comentario"
                        value={values.Comentario}
                        onChange={handleInputChange}
                        style={{ width: "100%" }}
                        labelStyle={{
                        color: "gray",
                        textShadow: "0px 0px 1px white",
                        }}
                        className={error.Comentario ? "p-invalid" : ""}
                    />
                    <label htmlFor="Comentario">Comentario</label>
                    </span>
                </div>
            </div>
          </div>
        </div>
      </Dialog>
    </div>
  );
};

export default VehiculosCRUD;
